import { useState } from 'react'

import { isTouchDevice } from '~/utils'

interface TooltipToggle {
  showTooltip: boolean
  handleOnClick: () => void
  handleOnMouseEnter: () => void
  handleOnMouseLeave: () => void
}

/**
 * Touch-aware tooltip visibility: hover shows/hides it on pointer devices, tap toggles
 * it on touch devices. Extracted so tooltip-trigger components don't each re-implement
 * the same show/hide state machine.
 */
export default function useTooltipToggle(): TooltipToggle {
  const [showTooltip, setShowTooltip] = useState(false)

  const handleOnClick = (): void => {
    if (isTouchDevice()) setShowTooltip((prev) => !prev)
  }
  const handleOnMouseEnter = (): void => {
    if (!isTouchDevice()) setShowTooltip(true)
  }
  const handleOnMouseLeave = (): void => {
    if (!isTouchDevice()) setShowTooltip(false)
  }

  return { showTooltip, handleOnClick, handleOnMouseEnter, handleOnMouseLeave }
}
